import Api from './rest/SupplierManualApi';

export default new Api();
